import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import { withRouter, Link } from 'react-router-dom';
import { connect } from "react-redux";
import * as actionTypes from '../../store/action';

import MobileMenu from './NavMobileMenu';

const styles = {
    root: {
        flexGrow: 1,
        letterSpacing: '1px'
    },
    grow: {
        flexGrow: 1,
    },
    logoText: {
        color: '#222222',
        fontSize: '24px',
        fontWeight: '700'
    },
    menuButton: {
        marginLeft: 0,
        marginRight: 0,
        color: '#222222'
    },
    menu: {
        marginLeft: 20,
        marginRight: 20,
        fontSize: '17px',
        color: '#222222',
        letterSpacing: '1px',
        textDecoration: "none",
        '&:hover': {
            color: "#e67300 "
        }
    },
    mobileMenu: {
        transition: '1s'
    }
};

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false
        }
    }


    mobileNavBarOpen = () => {
        this.setState((prevState) => {
            return {
                mobileNav: !prevState.mobileNav
            }
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <AppBar position="static">
                    <Toolbar>
                        <div className={classes.grow}>
                            <Typography variant="h5"><span className={classes.logoText}>𝐀𝐒𝐘𝐍𝐂𝐄𝐍𝐓𝐑𝐈𝐂</span></Typography>
                        </div>
                        <Hidden only={['xl', 'lg', 'md', 'sm']}>
                            {this.state.mobileNav ? <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.mobileNavBarOpen}>
                                <CloseIcon />
                            </IconButton> : <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={this.mobileNavBarOpen}>
                                    <MenuIcon />
                                </IconButton>}
                        </Hidden>
                        <Hidden only={['xs']}>
                            <Typography color="inherit"><span className={classes.menu}>Settings</span></Typography>
                            <Typography color="inherit" onClick={() => { this.props.deleteToken() }}><Link to="/admin" className={classes.menu}>Logout</Link></Typography>
                        </Hidden>
                    </Toolbar>
                    <Hidden only={['xl', 'lg', 'md', 'sm']}>
                        <Collapse in={this.state.mobileNav}>
                            <div className={classes.mobileMenu}><MobileMenu deleteToken={this.props.deleteToken} /></div>
                        </Collapse>
                    </Hidden>
                </AppBar>
            </div>
        );
    }
}

Navbar.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = dispatch => {
    return {
        deleteToken: () => dispatch({ type: actionTypes.TOKEN, token: "" }),
    }
}

export default connect(null, mapDispatchToProps)(withRouter(withStyles(styles)(Navbar)));